import styled from 'styled-components';

import { COLOURS } from './colour.constants';
import { rem } from 'approot/shared/style';
import { flexCentreAlignCss } from 'approot/shared/styles/flex.style';
import { ToolBarTool } from './toolbar.style';
import { grey5 } from 'approot/shared/styles/colours.style';

type ToolButtonProps = {
  $colour: string;
  $size: number;
  $isActive: boolean;
};
export const ToolbarPencilColourButton = styled(ToolBarTool).attrs({
  $borderRadius: 40,
})<ToolButtonProps>`
  ${flexCentreAlignCss}
  border: 1px solid ${grey5};

  &:before {
    content: '';
    background-color: ${({ $colour }) => $colour};
    border-radius: ${({ $size }) => rem($size)};
    height: ${({ $size }) => rem($size)};
    width: ${({ $size }) => rem($size)};
  }

  ${({ $isActive, $colour }) =>
    $isActive &&
    `
    background-color: ${COLOURS.find(c => c.base === $colour)?.colour1};
  
    &:hover {
      background-color: ${COLOURS.find(c => c.base === $colour)?.colour1};
      cursor: pointer;
    }
  `}
`;
